import React from "react";
import { useTranslation } from "react-i18next";

import Orders from "./Orders";
import Summary from "./Summary";
import BasicTabs from "components/BasicTabs";
import { ALL_PERMISSION } from "constants/permission";

const TAB_KEYS = {
  ORDERS: "order",
  SUMMARY: "summary",
};

const Affiliate = () => {
  const { t } = useTranslation();

  const listTab = [
    {
      key: TAB_KEYS.ORDERS,
      label: t("affiliate.tabs.orders"),
      permission: ALL_PERMISSION.MANAGE_AFFILIATE.permissionTab.MANAGE_LIST_ORDER.value,
      component: <Orders />,  // Đổi từ children → component
    },
    {
      key: TAB_KEYS.SUMMARY,
      label: t("affiliate.tabs.summary"),
      permission: ALL_PERMISSION.MANAGE_AFFILIATE.permissionTab.MANAGE_SUMMARY.value,
      component: <Summary />,  // Đổi từ children → component
    },
  ];

  return (
    <div className="affiliate-page">
      <BasicTabs 
        tabs={listTab} 
        permissionConstant={ALL_PERMISSION.MANAGE_AFFILIATE.permissionTab} 
      />
    </div>
  );
};

export default Affiliate;